<div class="pto-highlights-and-trends-main-container">
  <span class="highlights-and-trends-title">Highlights & Trends:</span>
  <div class="highlights-and-trends-cards">
    <div class="highlights-and-trends-card" *ngFor="let highlight of highlights">
      <app-trend-idicator-display [indicatorName]="highlight.type === 'medium' ? 'down': highlight.type === 'low' ? 'up' : 'critical'"></app-trend-idicator-display>
      <div class="descriptions-container">
        <span class="description title" [innerHTML]="highlight.title"></span>
        <!-- <span class="description score">Average score: <b>31%</b></span> -->
        <span class="description subtitle" [innerHTML]="highlight.description"></span>
      </div>
    </div>
  </div>
</div>
